import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import HeadingLines from '../assets/images/heading-lines.svg' 
// import frmccOne from '../assets/images/service-page/frmcc/1.svg' 
// import frmccTwo from '../assets/images/service-page/frmcc/2.svg' 
// import frmccThree from '../assets/images/service-page/frmcc/3.svg' 
// import frmccFour from '../assets/images/service-page/frmcc/4.svg' 

function MemoryCareCommunity({data}) {
  return (
    <>     
    <section className="dmcpc">
      <Container>
        <Row>
          <Col md="12">
              <div className="common-header">
                <img src={HeadingLines} alt="" />
                <h2>{data?.title}</h2> 
                <div dangerouslySetInnerHTML={{ __html: data?.description }}></div>  
              </div>
              <div className="stats-container">
                {data?.cards.map((row, index) => (
                  <div className="stat-item" key={"kk"+index}>
                    <img src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${row?.image}`} alt={row.title} />
                    <h3>{row.title}</h3>
                  </div>
                ))}
              </div>
          </Col>         
        </Row>        
      </Container>
    </section>
    </>
  )
}
export default MemoryCareCommunity